<template>
  <div id="cat_top" @mouseenter="showNav(true)" @mouseleave="showNav(false)" >
    <div class="title">
      <img src="img/class.png" />
      <span>{{ constant.allCategory }}</span>
    </div>
    <!--分类导航栏-->
    <div :style="style_cleft" class="c_left" v-show="isShowNav">
      <ul id="l_ul">
        <div v-for="(navItem, index) in navItems" :key="index">
          <li>
            <p>
              <span v-for="(levelOne, indexOne) in navItem" :key="indexOne">
                <a @click="searchByCat(levelOne, source)" :title="levelOne.name"
                  >{{ levelOne.name }}&nbsp;</a
                >
              </span>
            </p>
          </li>
          <div :style="style_box" class="box" id="box">
            <div class="bx_a">
              <div v-for="(levelOne, indexOne) in navItem" :key="indexOne">
                <div
                  class="case2"
                  v-for="(levelTwo, indexTwo) in levelOne.children"
                  :key="indexTwo"
                >
                  <div v-if="levelTwo.children.length > 0">
                    <a @click="searchByCat(levelTwo, source)">
                      <h5 :title="levelTwo.name">
                        {{ levelTwo.name }}&nbsp;&nbsp;&nbsp;&nbsp;
                      </h5>
                    </a>
                    <div class="cs2_a">
                      <div>
                        <div
                          v-for="(levelThree, indexThree) in levelTwo.children"
                          :key="indexThree"
                        >
                          <a
                            class="Tclass"
                            @click="searchByCat(levelThree, source)"
                            :title="levelThree.name"
                            >{{ levelThree.name }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: ["flexible"],
  data: function () {
    let nav = this.$store.state.malMainPageConfig.nav;
    let tempShow = nav.isShowAlways;
    let temp = true;
    //如果flexible为true, 则配置文件中的isShowAlways会失效;
    if (this.$props.flexible && this.$props.flexible === true) {
       temp = false;
       tempShow =false;
     }
    return {
      isShowNav: temp,
      isShowAlways: tempShow,
      style_cleft: {
        height: "380px",
      },
      style_box: {
        height: "380px",
      },
      constant: this.$store.state.malMainPageConfig.constant,
    };
  },
  computed: {
    // 监听导航栏动态改变
    navItems: function () {
      return this.$store.state.malMainPageConfig.nav.navItems;
    },
    source: function () {
      return this.$store.state.malMainPageConfig.nav.source;
    },
  },
  methods: {
    showNav(isShow) {
      if (this.isShowAlways) {
        //分类导航栏一直显示
        this.isShowNav = this.isShowAlways;
      } else {
        this.isShowNav = isShow;
      }
    },
    searchByCat(navItem, source) {
		var navName=encodeURIComponent(navItem.name);
    //如果是一二级分类，取值为当前编码
    var searchFields=encodeURIComponent(navItem.number);
    var navlevel=navItem.level;
    //如果是三级分类，取值为长编码
    if(navlevel=='3'){
      searchFields=encodeURIComponent(navItem.longNumber);
    }
		let url =
          axios.defaults.baseURL +
          "/index.html#/dform?formId=" + this.$store.state.malMainPageConfig.searchFormId + 
          "&source=" + source +
          "&searchText=" + navName +
          "&level=" + navlevel +
          "&searchFields=" + searchFields;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}
div {
  display: block;
}
#cat_top {
  width: 200px;
  height: 48px;
  background-color: #2386ee;
  color: #fff;
  padding: 0 10px;
  border-radius: 5px 5px 0px 0px;
  display:true;
}
#cat_top .title {
  height: 48px;
  display: flex;
  align-items: center;
  margin-left: 60px;
}
#cat_top .title img {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
#cat_top .title span {
  height: 48px;
  display: flex;
  align-items: center;
  font-size: 16px;
  width: 200px;
  // 苹方-简 中黑体
  font-family: PingFangSC-Medium, sans-serif;
}
.content > ul > li {
  float: left;
  height: 44px;
  line-height: 44px;
  padding: 0 20px;
  font-size: 15px;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
.content li > a {
  color: black;
}
.c_left {
  width: 220px;
  background-color: #ffffff;
  font-size: 14px;
  color: #333333;
  position: relative;
  right: 10px;
  z-index: 3000;
}
.c_left a {
  padding: 0 2px;
  cursor: pointer;
}

.c_left ul {
  padding: 5px 0;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 365px;
}
.c_left ul::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
.c_left li {
  height: 20px;
  padding: 5px 0 5px 10px;
  position: relative;
}
.c_left li:hover + .box {
  display: block;
}
.c_left .box:hover {
  display: block;
}
.c_left li p {
  float: left;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  position: absolute;
}
/*轮播图左边第一个二级菜单*/
.c_left .box {
  float: left;
  width: 980px;
  position: absolute;
  left: 220px;
  top: 0px;
  background-color: #ffffff;
  z-index: 3000;
  font-size: 12px;
  display: none;
  overflow-y: auto;
}

.c_left .box .bx_a .case2 a {
  float: left;
  height: 30px;
  line-height: 30px;
  padding: 0 7px 0 0;
  text-align: center;
}
.c_left .box .bx_a .case2 a:hover {
  color: #2386ee;
}
/*轮播图左边第一个二级菜单END*/
.c_left li:hover {
  background: #f2f6ff;
  color: #2386ee;
  width: 210px;
  height: 20px;
}
.bx_a {
  float: left;
  overflow: hidden;
  padding: 10px 20px;
}
.cs2_a {
  width: 820px;
  float: left;
  border-bottom: 1px solid #eeeeee;
  overflow: hidden;
}
.case2 h5 {
  text-align: center;
  width: 100px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.Tclass {
  margin: 0 10px 0 0;
}
</style>
